export function initSite() {
  const navbar = document.getElementById('navbar')
  const header = document.getElementById('header')
  const toggle = document.querySelector('.mobile-nav-toggle')
  const dropdown = document.querySelector('.navbar .dropdown')
  const backToTop = document.getElementById('back-to-top')

  toggle?.addEventListener('click', () => {
    navbar?.classList.toggle('navbar-mobile')
    toggle.classList.toggle('bi-list')
    toggle.classList.toggle('bi-x')
  })

  dropdown?.querySelector(':scope > a')?.addEventListener('click', (event) => {
    if (navbar?.classList.contains('navbar-mobile')) {
      event.preventDefault()
      dropdown.querySelector(':scope > ul')?.classList.toggle('dropdown-active')
    }
  })

  function closeMobileNav() {
    if (!navbar?.classList.contains('navbar-mobile')) return
    navbar.classList.remove('navbar-mobile')
    toggle?.classList.add('bi-list')
    toggle?.classList.remove('bi-x')
  }

  function scrollToHash(hash: string) {
    const section = document.querySelector(hash)
    if (!(section instanceof HTMLElement) || !header) return
    let offset = header.offsetHeight
    if (!header.classList.contains('header-scrolled')) {
      offset -= 16
    }
    window.scrollTo({
      top: Math.max(section.offsetTop - 80 - offset, 0),
      behavior: 'smooth',
    })
  }

  document.querySelectorAll<HTMLAnchorElement>('a.scrollto').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!link.hash || !isSamePage(link)) return
      const section = document.querySelector(link.hash)
      if (!(section instanceof HTMLElement)) return
      event.preventDefault()
      closeMobileNav()
      scrollToHash(link.hash)
    })
  })

  const onScroll = () => {
    const scrolled = window.scrollY
    header?.classList.toggle('header-scrolled', scrolled > 100)
    backToTop?.classList.toggle('active', scrolled > 100)
    updateActiveNav()
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1200) {
      closeMobileNav()
    }
  })
  onScroll()

  if (window.location.hash && document.querySelector(window.location.hash)) {
    window.setTimeout(() => scrollToHash(window.location.hash), 0)
  }

  backToTop?.addEventListener('click', (event) => {
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })

  initLegacyAccordion(document)
}

function isIndexPath(path: string) {
  const normalized = path.toLowerCase().replace(/\/+$/, '')
  return normalized === '' || normalized.endsWith('/index.html') || normalized.endsWith('/index')
}

function isSamePage(link: HTMLAnchorElement) {
  try {
    const url = new URL(link.href, window.location.href)
    return url.pathname.replace(/\/+$/, '') === window.location.pathname.replace(/\/+$/, '') ||
      (isIndexPath(url.pathname) && isIndexPath(window.location.pathname))
  } catch {
    return false
  }
}

function setActiveNav(target: string | HTMLAnchorElement) {
  document.querySelectorAll('#navbar .nav-link, #navbar [data-nav]').forEach((el) => {
    el.classList.remove('active')
  })
  if (typeof target === 'string') {
    document.querySelectorAll<HTMLAnchorElement>('#navbar [data-nav]').forEach((link) => {
      if (link.dataset.nav === target) {
        link.classList.add('active')
      }
    })
    return
  }
  target.classList.add('active')
}

function updateActiveNav() {
  const path = window.location.pathname.toLowerCase()
  const pageKey = resolveNavKey(path)
  if (pageKey !== 'home' || !isIndexPath(path)) {
    setActiveNav(pageKey)
    return
  }

  const position = window.scrollY + 200
  let current: HTMLAnchorElement | null = null
  document.querySelectorAll<HTMLAnchorElement>('#navbar a.scrollto').forEach((link) => {
    if (!link.hash) return
    const section = document.querySelector(link.hash)
    if (!(section instanceof HTMLElement)) return
    if (position >= section.offsetTop && position <= section.offsetTop + section.offsetHeight) {
      current = link
    }
  })
  setActiveNav(current ?? 'home')
}

function resolveNavKey(path: string) {
  if (path.includes('investorcharter')) return 'charter'
  if (path.includes('clients')) return 'clients'
  if (
    path.includes('customercontactupdate') ||
    path.includes('rightsissue') ||
    path.includes('firstcallmoney') ||
    path.includes('openexitoffer')
  ) {
    return 'services'
  }
  return 'home'
}

let accordionDelegated = false

export function initLegacyAccordion(_root?: ParentNode) {
  if (accordionDelegated) return
  accordionDelegated = true

  document.addEventListener('click', (event) => {
    const target = event.target
    if (!(target instanceof Element)) return
    const button = target.closest<HTMLElement>('.accordion-button')
    if (!button?.closest('.legacy-accordion')) return

    event.preventDefault()
    const accordion = button.closest('.accordion')
    const targetSel = button.getAttribute('data-bs-target')
    const item = button.closest('.accordion-item')
    const panel = (targetSel && (accordion?.querySelector(targetSel) || document.querySelector(targetSel))) ||
      item?.querySelector(':scope > .accordion-collapse')
    if (!(panel instanceof HTMLElement)) return

    const open = panel.classList.contains('show')
    const scope = accordion ?? button.closest('.legacy-accordion') ?? document
    scope.querySelectorAll('.accordion-collapse').forEach((el) => el.classList.remove('show'))
    scope.querySelectorAll('.accordion-button').forEach((el) => {
      el.classList.add('collapsed')
      el.setAttribute('aria-expanded', 'false')
    })
    if (!open) {
      panel.classList.add('show')
      button.classList.remove('collapsed')
      button.setAttribute('aria-expanded', 'true')
    }
  })
}
